import React from 'react';

const BalanceHead: React.FC = React.memo(() => {
  return <div style={{ textAlign: 'center' }}>Balance</div>;
});

export default BalanceHead;
